// extracted by mini-css-extract-plugin
export default {"search":"Search--search---QS3o","search__input":"Search--search__input--2w+n4","search__arrow":"Search--search__arrow--yPay5"};